import { IconComponentProps } from './index'

const OneOffEmail = ({ width = 32, height = 32, color = 'currentColor', customClass = '' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg' className={customClass}>
  <g clip-path='url(#clip0_4328_121276)'>
    <path d='M29.8327 15.4987V7.9987C29.8327 6.53203 28.6327 5.33203 27.166 5.33203H5.83268C4.36602 5.33203 3.16602 6.53203 3.16602 7.9987V23.9987C3.16602 25.4654 4.36602 26.6654 5.83268 26.6654H18.4995' stroke={color} stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
    <path d='M29.8327 8L16.4993 17.3333L3.16602 8' stroke={color} stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
    <circle cx='26.5' cy='24' r='5.45' stroke={color} stroke-width='1.1' />
    <path d='M24.8052 21.648C25.2599 21.582 25.6705 21.4463 26.0372 21.241C26.4112 21.0357 26.7082 20.7937 26.9282 20.515H28.6112L27.1152 27.5H24.7392L25.8282 22.385H24.6402L24.8052 21.648Z' fill={color} />
  </g>
  <defs>
    <clipPath id='clip0_4328_121276'>
      <rect width='32' height='32' fill='white' transform='translate(0.5)' />
    </clipPath>
  </defs>
</svg>

export default OneOffEmail
